<template>
  <div class="the-lng-settings">
    <h3>Настройки языков приложения</h3>
    <div class="the-lng-settings__list">
      <el-button
        class="the-lng-settings__item"
        size="small" v-for="(item, index) in lngArray"
        :key="index"
        @click="setLngToEdit(item.code)"
        :type="activeLng === item.code ? 'primary' : 'defaulte'"
        round
      >
        {{item.title}}
      </el-button>
    </div>

    <div class="the-lng-settings__add">
      <el-button @click="handleAdd" type="success" round>Add</el-button>
    </div>

    <hr>

    <div
      v-if="activeLng !== null"
      class="the-lng-settings__form"
    >
      <el-row :gutter="20" class="the-lng-settings__row">
        <el-col :span="8" class="s-token-edit-form__label">Language code:</el-col>
        <el-col :span="16"><el-input placeholder="Language code" v-model="code"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="the-lng-settings__row">
        <el-col :span="8" class="s-token-edit-form__label">Language title:</el-col>
        <el-col :span="16"><el-input placeholder="Language title" v-model="title"></el-input></el-col>
      </el-row>

      <el-row :gutter="20" class="the-lng-settings__row">
        <el-col :span="8" class="s-token-edit-form__label">Language icon:</el-col>
        <el-col :span="12"><el-input placeholder="Language icon" type="textarea" :rows="4" v-model="icon"></el-input></el-col>
        <el-col :span="4">
          Icon preview:<br>
          <div
            class="the-lng-settings__icon"
            v-if="icon !== ''"
            v-html="icon"
          >
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="the-lng-settings__row the-lng-settings__row_buttons">
        <el-button @click="handleSave" type="success" round>Save</el-button>
        <el-button @click="handleDelete" type="danger" round>Delete</el-button>
        <el-button @click="handleCancel" round>Cancel</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
/**
 * Component: the-lng-settings - Компонент настройки поддерживаемых приложениям языков
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'the-lng-settings',

  data() {
    return {
      // Активный редактируемый язык
      activeLng: null,

      code: '',
      title: '',
      icon: '',
    };
  },

  computed: {
    // Массив с языками системы
    lngArray() {
      return Object.keys(this.lng).map(key => ({
        code: key,
        title: this.lng[key].title,
      }));
    },

    ...mapGetters({
      lng: 'settings/lng',
    }),
  },

  methods: {
    handleAdd() {
      this.activeLng = '';
    },

    // Установка редактируемого языка
    setLngToEdit(code) {
      console.log('setLngToEdit');
      this.activeLng = code;
      this.code = code;
      this.title = this.lng[code].title;
      this.icon = this.lng[code].icon;
    },

    // Сохранение языка
    async handleSave() {
      if (this.code) {
        const { error } = await this.addLng({
          code: this.code,
          title: this.title,
          icon: this.icon,
          });
        if (error) {
          this.$notify({
            title: 'Add Language Error',
            message: error.message,
            duration: 0,
          });
        } else {
          this.handleCancel();
          this.getAppSettings();
        }
      }
    },

    // Удалене языка
    async handleDelete() {
      if (this.activeLng) {
        const { error } = await this.deleteLng(this.activeLng);
        if (error) {
          this.$notify({
            title: 'Delete Language Error',
            message: error.message,
            duration: 0,
          });
        } else {
          this.handleCancel();
          this.getAppSettings();
        }
      }
    },

    // Отмена редакировая
    handleCancel() {
      this.activeLng = null;
      this.code = '';
      this.title = '';
      this.icon = '';
    },

    ...mapActions({
      addLng: 'settings/addLng',
      deleteLng: 'settings/deleteLng',
      getAppSettings: 'settings/getAppSettings',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-lng-settings {
  $this: &;

  &__list {
    margin-bottom: 2 * $vp;
  }

  &__add {
    margin-bottom: 2 * $vp;
  }

  &__form {
    margin-top: 2 * $vp;
  }

  &__row {
    margin-bottom: $vp;

    &_buttons {
      margin-top: 2 * $vp;
    }
  }

  &__label {
    line-height: 40px;
    text-align: right;
    padding-right: $hp;
  }

  &__icon {
    width: 50px;
    height: 50px;
    margin: 10px auto;
  }
}
</style>
